/**
 * Created by Jerker Nord on 2021-01-27.
 */
import { NolimitAudioPlayer } from '@nolimitcity/slot-audio/bin/NolimitAudioPlayer';
import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { GameMode } from '@nolimitcity/slot-game/bin/flowcontrol/GameMode';
import { GameSetting } from '../../core/setting/GameSetting';
import { Logger } from '@nolimitcity/slot-launcher/bin/utils/Logger';

export class BeheadedSound {
    
    public static REELS_LANDING: string[] = ['reelLand01', 'reelLand02', 'reelLand03', 'reelLand04', 'reelLand05'];
    public static MAIN_GAME_MUSIC: string = 'background-music-main';
    public static AS_WIN: string = 'asWin';
    public static AS_WIN_BIG: string = 'asBigWin';

    // Countup sound
    public static COUNT_UP: string = 'countup';
    public static COUNT_UP_ENDS: string[] = ['countupEndsTiny', 'countupEndsSmall', 'countupEndsMedium', 'countupEndsLarge'];

    // Big win sound
    public static BIG_WIN_INTRO: string = 'bigwinIntro';
    public static BIG_WIN: string[] = ['bigwin1', 'bigwin2', 'bigwin3', 'bigwin4', 'bigwin5'];
    public static BIG_WIN_END = 'bigwinEnd';

    private _currentMusic: string;

    private player: NolimitAudioPlayer;

    constructor() {
        this.player = <NolimitAudioPlayer>SlotGame.sound;
        this.player.showLogs(GameSetting.isDevMode);
    }

    public static get soundPlayer(): NolimitAudioPlayer {
        return <NolimitAudioPlayer>SlotGame.sound;
    }

    private static createConfig(name: string, volume?: number, repeat?: number) {
        return {
            name: name,
            volume: volume,
            repeat: repeat,
        };
    }
    private static createConfigFade(name: string, from: number, to: number, duration: number) {
        return {
            name: name,
            from: from,
            to: to,
            duration: duration,
        };
    }

    public playSound(name: string, volume?: number, repeat?: number) {
        Logger.logDev('Sound Played: ', name);
        this.player.playTrack(BeheadedSound.createConfig(name, volume, repeat));
    }

    public stopSound(name: string) {
        Logger.logDev('Sound Stopped: ', name);
        this.player.stopTrack(name);
    }

    public fadeSound(name: string, from: number, to: number, duration: number) {
        Logger.logDev('Sound Faded: ', name);
        this.player.fadeTrack(BeheadedSound.createConfigFade(name, from, to, duration));
    }

    public switchMusic(mode: GameMode | string) {
        let nextMusic = '';

        switch (mode) {
            case GameMode.FREESPIN:
                //nextMusic = BeheadedSound.FREESPIN;
                break;
            default:
                nextMusic = BeheadedSound.MAIN_GAME_MUSIC;
                break;
        }

        if (nextMusic == this._currentMusic) {
            return;
        }

        if (this._currentMusic) {
            this.player.stopTrack(this._currentMusic);
        }
        Logger.logDev('Sound Music Played: ', nextMusic);
        this.player.playTrack(BeheadedSound.createConfig(nextMusic, 1, undefined));
        this._currentMusic = nextMusic;
    }
}
